import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';

export default class MessageReportNotification extends Notification {
  icon() { return 'fas fa-shield-alt'; }
  href() {
    const data = this.attrs.notification.content();
    return app.forum.attribute('canReviewMessages')
      ? `${app.route('yingtaoMessageReports')}#message-report-${encodeURIComponent(data.reportId)}`
      : app.route('yingtaoMessages');
  }
  content() {
    const status = this.attrs.notification.content().status;
    return app.translator.trans(`yingtao-forum-homepage.forum.private_messages.${status === 'pending' ? 'report_created' : `status_${status}`}`);
  }
  excerpt() { return null; }
}
